
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import moment from 'moment';
import { Route } from 'vue-router';
import scheduledStatus from '@/enums/scheduledStatus';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { scheduledmessage } = api;

@Component({
  components: { ItemForm },
})
export default class ScheduledMessageEdit extends Vue {
  @Prop({}) private id!: string;

  private readOnly: boolean = true;

  private form = {
    msgFrom: null,
    msgBody: null,
    msgLink: null,
    isEnabled: null,
    addressFilter: null,
    sendTime: null,
  };

  private loading: boolean = false;

  private async submit(form: any) {
    if (!this.readOnly && form) {
      this.loading = true;
      const { status } = await scheduledmessage.edit(this.id, form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.form = data;
  }

  private setReadOnly(status: number) {
    if (status !== scheduledStatus.Sent) {
      this.readOnly = false;
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: ScheduledMessageEdit) => void) => void,
  ) {
    const { id } = to.params;
    const { data } = await scheduledmessage.get(id);
    data.sendTime = moment(data.sendTime).format('YYYY-MM-DD HH:mm');
    await next(async (vm) => {
      vm.setReadOnly(data.status);
      vm.setForm(data);
    });
  }
}
